import Vue from 'vue'

import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCES,
  GET_MENUS_SUCCESS,
  LOGIN_SUCCESS_AD,
  CHANGE_USERSCHOOL,
  SHOW_VERITY
}
  from './mutation-type'
import util from '../../../../src/utils/index.js'

const mutations = {
  [LOGIN_SUCCESS] (state, data) {
    state.roleId = data.roles.length > 0 ? data.roles[0].id : ''
    state.userInfo = data;
    state.showVerity = false

    Vue.prototype.$schoolId = state.userInfo.schoolType === 1 ? state.userInfo.regionId : state.userInfo.schoolId
    Vue.prototype.$schoolType = state.userInfo.schoolType
    if (window.xkwTracker) {
      window.xkwTracker.$user_id = data.xkwUserId
      window.xkwTracker.$school_id = data.xkwSchoolId
    }
    YJ_REGION_STORAGE.setItem('userInfo', JSON.stringify(data));
  },
  [LOGOUT_SUCCES] (state, data) {
    state.roleId = '';
    state.userInfo = '';
    if (window.xkwTracker) {
      window.xkwTracker.$user_id = ''
      window.xkwTracker.$school_id = ''
    }
  },
  [GET_MENUS_SUCCESS] (state, data) {
    state.menus = data
  },
  [LOGIN_SUCCESS_AD] (state, data) {
    state.isAdmin = data
  },
  [SHOW_VERITY] (state, data) {
    state.showVerity = data
  },
  [CHANGE_USERSCHOOL] (state, _userInfo) {
    state.userInfo.schoolId = _userInfo.id;
    state.userInfo.schoolName = _userInfo.schoolName;
    YJ_REGION_STORAGE.setItem('userInfo', JSON.stringify(state.userInfo)); // 数据量太大，先不保存
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/modules/login/mutations.js